// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Googledrive = createSvgIcon(
  { All: <React.Fragment><g fill="currentColor" stroke="transparent"><path d="M5.581 23.3034l3.7778-6.5767h14.5713l-3.7777 6.5767H5.5811zM7.3145 3.4452l3.7864 6.5716L3.8153 22.681.0289 16.1094 7.3145 3.4452zM23.98 15.3508l-7.5641.005L9.1302 2.6917l7.5642-.005L23.98 15.3507z" /></g><defs></defs></React.Fragment>, },
  'default'
);
